import styled from '@emotion/styled';
import { Button } from 'react-magma-dom';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledLessonButton = styled(Button)<{
  bgColor?: string;
}>`
  ${DOTTED_FOCUS}
  font-weight: normal!important;
  line-height: normal;
  color: ${COLORS.white}!important;

  background-color: ${({ bgColor }) => bgColor || COLORS.cadmiumViolet}!important;
  text-decoration: none !important;
  margin-top: 20px !important;
  padding: 11px 22px 13px 12px !important;
  min-height: 49px !important;
  height: auto !important;
  border-radius: 0 !important;
  justify-content: flex-start !important;
  white-space: normal !important;
  text-align: left !important;
  margin-left: 0 !important;
  margin-right: 0 !important;

  :not([disabled])${DOTTED_FOCUS} p {
    margin: 0 !important;
    padding: 0 8px 0 18px !important;
  }

  :hover,
  :focus,
  :active {
    background-color: ${({ bgColor }) => bgColor || COLORS.cadmiumViolet} !important;
  }

  :disabled {
    color: ${COLORS.white}!important;
  }

  > span {
    width: 100% !important;
  }
`;
